/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_redondo.svg'
import {GRADIENTE, SECCIONES, URLUSUARIO} from "../../Constantes";
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {irUrl} from "../../Utilidades/irUrl";


const BarraPc = () => {
    const navigate = useNavigate();


    const irRuta = (secc) => {

        switch (secc) {
            case SECCIONES[1]:
                navigate('/Testimonios');
                break
            case SECCIONES[0]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('sistema')
                }, 500)
                break
            case SECCIONES[2]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('calendario')
                }, 500)
                break
        }

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >
                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <img
                                onClick={() => navigate('/Home')}
                                src={logo} width={80} height={'auto'} style={{cursor: 'pointer'}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        onClick={() => irRuta(item)}
                                        sx={{
                                            cursor: 'pointer',
                                            transition: 'all .2s ease-in-out',
                                            fontFamily: 'Inter',
                                            color: '#4A5157',
                                            fontWeight: 600,
                                            borderBottom: 2,
                                            fontSize: 15,
                                            mt: 0.5,
                                            borderColor: 'transparent',
                                            '&:hover': {
                                                color: theme.palette.primary.main,
                                                borderColor: theme.palette.primary.main
                                            }
                                        }}
                                    >{item}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1.2}
                            >

                                <Button
                                    onClick={() => irUrl(URLUSUARIO + 'registro')}
                                    variant={'outlined'}> Registro</Button>

                                <Button
                                    onClick={() => irUrl(URLUSUARIO + 'ingreso')}
                                    sx={{background: GRADIENTE}}> Ingresar</Button>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc

